export default "__VITE_ASSET__796d0e38__"